import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { BaseWebAppLayout } from '@/ui/layout/components/BaseWebAppLayout.tsx';
import { NotFound } from '@/ui/components/NotFound';
import { NotLoggedIn } from '@/ui/components/NotLoggedIn';
import { AppRouterContext } from '@/router';
import { CookieConsentBanner } from "@/features/analytics/components/CookiesConsentBanner.tsx";
import { useClarity } from '@/features/analytics/hooks/useClarity';

export const Route = createRootRouteWithContext<AppRouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
})

function RootLayout() {
  const {auth} = Route.useRouteContext();
  useClarity();

  // Show login screen if not authenticated
  if (!auth.isAuthenticated) {
    return (
      <>
        <NotLoggedIn/>
        <TanStackRouterDevtools/>
      </>
    );
  }

  return (
    <>
      <BaseWebAppLayout>
        <Outlet/>
      </BaseWebAppLayout>
      <CookieConsentBanner privacyPolicyUrl="/dpa/"/>
      <TanStackRouterDevtools/>
    </>
  );
}